import ModalGraficos from '@core/components/ModalGraficos';
import { Grid } from '@material-ui/core';
import { getCurrency } from 'app/utils/monetarioUtil';
import moment from 'moment';
import React, { useContext } from 'react';
import { ContaReceberContext } from '../../contaReceberContext';
import ContaReceberGraficoQuantidade from '../graficos/ContaReceberGraficoQuantidade';
import ContaReceberGraficoSomatorios from '../graficos/ContaReceberGraficoSomatorios';
import { contaReceberModais } from './contaReceberModais';

const ContaReceberGraficosModal = () => {
  const [modal, setModal] = useContext(ContaReceberContext).modal;
  const [somatorios] = useContext(ContaReceberContext).somatorios;
  const [filtroAvancado] = useContext(ContaReceberContext).filtroAvancado;
  const [search] = useContext(ContaReceberContext).search;

  const handleClose = () => {
    setModal('');
  };

  const primeiraLetraMaiuscula = (palavra) => {
    const formatada = palavra[0].toUpperCase() + palavra.substr(1).toLowerCase();
    return formatada;
  };

  const formatarOrigemLancamento = (palavra) => {
    let palavraFormatada = '';

    if (palavra === 'CONTRATO') {
      palavraFormatada = 'Contratos';
    } else if (palavra === 'VENDA') {
      palavraFormatada = 'Vendas';
    } else if (palavra === 'CONTA_RECEBER') {
      palavraFormatada = 'Contas a receber';
    }

    return palavraFormatada;
  };

  const getFiltroUtilizado = () => {
    const filtros = [];

    if (search) {
      filtros.push(`Pesquisa: "${search}"`);
    } else if (Object.keys(filtroAvancado).length === 0) {
      filtros.push(`Situação: "${primeiraLetraMaiuscula('aberta')}"`);
      filtros.push(`Mês de vencimento: "${moment().format('MM/YYYY')}"`);
    }

    if (filtroAvancado?.dataEmissao) {
      filtros.push(`Data de emissão: "${filtroAvancado.dataEmissao.format('DD/MM/YYYY')}"`);
    }

    if (filtroAvancado?.mesCompetencia) {
      filtros.push(`Mês competência: "${filtroAvancado.mesCompetencia.format('MM/YYYY')}"`);
    }

    if (filtroAvancado?.situacao) {
      filtros.push(`Situação: "${primeiraLetraMaiuscula(filtroAvancado.situacao)}"`);
    }

    if (filtroAvancado?.cliente?.nome) {
      filtros.push(`Cliente: "${filtroAvancado.cliente?.nome}"`);
    }

    if (filtroAvancado?.categoria?.nome) {
      filtros.push(`Categoria: "${filtroAvancado.categoria?.nome}"`);
    }

    if (filtroAvancado?.dataVencimento) {
      filtros.push(`Data de vencimento: "${filtroAvancado.dataVencimento.format('DD/MM/YYYY')}"`);
    }

    if (filtroAvancado?.dataRecebimentoInicio && filtroAvancado?.dataRecebimentoFim) {
      filtros.push(
        `Período de recebimento: "${filtroAvancado.dataRecebimentoInicio.format(
          'DD/MM/YYYY'
        )}" a "${filtroAvancado.dataRecebimentoFim.format('DD/MM/YYYY')}"`
      );
    }

    if (filtroAvancado?.dataLiquidacaoInicio && filtroAvancado?.dataLiquidacaoFim) {
      filtros.push(
        `Período de liquidação: "${filtroAvancado.dataLiquidacaoInicio.format(
          'DD/MM/YYYY'
        )}" a "${filtroAvancado.dataLiquidacaoFim.format('DD/MM/YYYY')}"`
      );
    }

    if (filtroAvancado?.dataVencimentoInicio && filtroAvancado?.dataVencimentoFim) {
      filtros.push(
        `Período de vencimento: "${filtroAvancado.dataVencimentoInicio.format(
          'DD/MM/YYYY'
        )}" a "${filtroAvancado.dataVencimentoFim.format('DD/MM/YYYY')}"`
      );
    }

    if (filtroAvancado?.valorBruto) {
      filtros.push(`Valor: "${getCurrency(filtroAvancado.valorBruto)}"`);
    }

    if (filtroAvancado?.nossoNumero) {
      filtros.push(`Nosso número: "${filtroAvancado.nossoNumero}"`);
    }

    if (filtroAvancado?.documentoFiscal) {
      filtros.push(`Documento fiscal: "${filtroAvancado.documentoFiscal}"`);
    }

    if (filtroAvancado?.origemLancamento) {
      filtros.push(`Origem do lançamento: "${formatarOrigemLancamento(filtroAvancado.origemLancamento)}"`);
    }

    if (filtroAvancado?.conta?.descricao) {
      filtros.push(`Conta: "${filtroAvancado.conta.descricao}"`);
    }

    if (filtroAvancado?.apenasRegulares) {
      filtros.push(`Apenas receitas regulares`);
    }

    return `Filtros utilizados: ${filtros.join(', ')}`;
  };

  return (
    <ModalGraficos
      titulo="Indicadores do Contas a Receber"
      open={modal === contaReceberModais.indicadores}
      onClose={handleClose}
      nomeArquivo="Indicadores Contas a receber"
      rodape={getFiltroUtilizado()}
    >
      <div style={{ padding: 16, alignItems: 'center', justifyContent: 'center' }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <ContaReceberGraficoSomatorios values={somatorios} />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <ContaReceberGraficoQuantidade values={somatorios} />
          </Grid>
          {/* <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
            <ContaReceberGraficoPrevisaoOrcamentaria values={somatorios} />
          </Grid> */}
        </Grid>
      </div>
    </ModalGraficos>
  );
};

export default ContaReceberGraficosModal;
